define('widgets/nav',[
	'jquery',
	'modules/page',
	'widgets/widgets',
	'lib/jquery.support.cssproperty',
	'lib/jquery.mousewheel'
], function ($, page) {

	return $.widget('muse.nav', {

		enabled: null,

		_create: function () {

			this.$toggle = $('#nav-toggle');
			this._on(this.$toggle, {
				'click': $.proxy(this, 'onClickToggle')
			});

			this.$main = $('#main');
			this._on(this.$main, {
				'click .title.slide': $.proxy(this, 'onClickTitle'),
				'mousewheel': $.proxy(this, 'onMouseWheelMain')
			});

			this._on({
				'click h1': $.proxy(this, 'onClickLogo'),
				'click': $.proxy(this, 'onClickNav'),
				'mousewheel': $.proxy(this, 'onMouseWheel')
			});

			this.transition = $.support.cssProperty('transition');
			$.subscribe('appReady', $.proxy(this, 'update'));
			$.subscribe('slide', $.proxy(this, 'onSlide'));

			this.element.widgets();
			this.update();

			return this._super();

		},

		onClickTitle: function() {

			if (page.$html.hasClass('nav-enabled'))
				this.toggle();

		},

		onClickToggle: function () {

			this.toggle();

		},

		onClickNav: function (e) {

			if (this.enabled)
				this.toggle();

		},

		onClickLogo: function(e) {

			e.stopPropagation();

		},

		toggle: function () {

			if (this.timer)
				return;

			this.timer = setTimeout($.proxy(function () {
				page.$html.toggleClass('nav-enabled');
				this.timer = null;
				this.update();
			}, this), this.enabled ? 200 : 0);

			this.debounce = setTimeout($.proxy(function () {
				this.debounce = null;
			}, this), 2000);
		},

		update: function () {

			var enabled = page.$html.hasClass('nav-enabled');
			if (enabled === this.enabled)
				return;

			if (this.transition && this.enabled !== null) {
				this.$main.one('transitionend', function (e) {
					$.publish('navChange', enabled);
				});
			} else {
				$.publish('navChange', enabled);
			}

			if (enabled) page.$body.scrollTop(0);
			this.enabled = enabled;

		},

		onMouseWheel: function (e) {

			if (this.debounce)
				return e.preventDefault();

			if (this.enabled && e.deltaX > 0 && (Math.abs(e.deltaX) > Math.abs(e.deltaY)))
				this.toggle();

		},

		onMouseWheelMain: function (e) {

			if (this.debounce)
				return e.preventDefault();

			if (this.$main.children().hasClass('vertical-layout'))
				return;

			if (!this.enabled && e.deltaX < 0 && (Math.abs(e.deltaX) > Math.abs(e.deltaY)))
				this.toggle();

		},

		onSlide: function () {

			if (this.enabled) this.toggle();

		}

	});

});
